module.exports = "<my-commande-display my-commande=\"$$commande.data.myCommande\"\n  my-wagons=\"$$commande.data.myWagons\"\n  enable-local-search=\"true\"\n  enable-title=\"true\"\n  enable-badges=\"true\"\n  enable-buttons=\"true\"\n  enable-excel=\"true\"\n  enable-links=\"true\"\n  enable-back=\"true\">\n</my-commande-display>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/commande/templates/details.html
// module id = 1556
// module chunks = 0